import {createFieldRenderer, RawFieldRenderer} from 'forms';
import classNames from 'classnames';
import React from 'react';
import TableCellRenderer from './TableCellRenderer';
import TableHeadingRenderer from './TableHeadingRenderer';

/**
 * Renders a field as a panel.
 *
 * This is designed to work mainly with CollectionField.
 */
const PanelRenderer = createFieldRenderer(({
    className = '',
    error = null,
    factory,
    innerClassName = '',
    label,
    ...props
}) => <div
        className={classNames(
            className,
            'panel',
            `field-renderer-${props.name}`,
            { [`panel-${props.panel}`]: props.panel as any },
            { 'has-error': !!error }
        )}>
    {label && <div className="panel-heading">
        <h3 className="panel-title">{label}</h3>
    </div>}
    <table className="table">
        <thead>
            <tr>
                {factory({
                    Renderer: RawFieldRenderer,
                    SubRenderer: TableHeadingRenderer,
                    ...props,
                    className: classNames(innerClassName),
                })}
            </tr>
        </thead>
        <tbody>
            <tr>
                {factory({
                    Renderer: RawFieldRenderer,
                    SubRenderer: TableCellRenderer,
                    ...props,
                    className: classNames(innerClassName),
                })}
            </tr>
        </tbody>
    </table>
</div>);

export default PanelRenderer;
